<script setup>
import suitcase from "@/assets/images/chronology/suitcase.svg";
import pdf from "@/assets/images/chronology/pdf.svg";
import board from "@/assets/images/chronology/board.svg";
import link from "@/assets/images/chronology/link.svg";
import offer from "@/assets/images/chronology/offer.svg";
import schot_faktura from "@/assets/images/chronology/schot_faktura.svg";
import payments from "@/assets/images/chronology/payments.svg";
import pudratchi from "@/assets/images/chronology/pudratchi.svg";
import flag from "@/assets/images/chronology/flag.svg";
import organization from "@/assets/images/chronology/organization.svg";
import document from "@/assets/images/chronology/document.svg";
import boardBg from "@/assets/images/chronology/board_bg.png";
import image1 from "@/assets/images/chronology/in_1.jpeg";
import image2 from "@/assets/images/chronology/in_2.jpeg";
import image3 from "@/assets/images/chronology/in_3.jpeg";

import { ref } from "vue";

const props = defineProps({
  item: {
    type: Object,
    required: true,
    default: null,
  },
});

const photos = ref([image1, image2, image3]);
</script>

<template>
  <h4 class="title animateWrapper">{{ item.orderer_title }}</h4>
  <div v-if="item && item.id == 1" class="chronology animateWrapper">
    <fieldset class="">
      <legend>
        <img :src="suitcase" alt="suitcase" />
        <span>Буюртмачи ташкилот</span>
      </legend>
      <div class="field">
        <div>
          <p>Номи:</p>
          <span>{{ item.customerName || "aniqlanmagan" }}</span>
        </div>
        <div>
          <p>СТИР:</p>
          <span>{{ item.customerTin || "aniqlanmagan" }}</span>
        </div>
        <div>
          <p>Манзил:</p>
          <span>{{ item.address || "aniqlanmagan" }}</span>
        </div>
        <div>
          <p>Раҳбари:</p>
          <span>{{ item.customerDirector || "aniqlanmagan" }}</span>
        </div>
      </div>
    </fieldset>
    <div class="accounts-wrapper">
      <p class="account">Лойиҳани молиялаштириш учун очилган ҳисобрақамлар:</p>
      <fieldset>
        <legend>{{ item.Accounts || "aniqlanmagan" }}</legend>
        <div class="field">
          <div>
            <p>Жами ажратилган:</p>
            <span>{{ item.distributedSumma || "aniqlanmagan" }}</span>
          </div>
          <div>
            <p>Молиялаштирилган:</p>
            <span>{{ item.paidOnlineSumma || "aniqlanmagan" }}</span>
          </div>
          <div>
            <p>Қолдиқ:</p>
            <span>{{ item.lastAmount || "aniqlanmagan" }}</span>
          </div>
        </div>
      </fieldset>
    </div>

    <fieldset>
      <legend>Буюртмачини белгилашга асос:</legend>
      <div class="field">
        <div>
          <p>Хужжат номи:</p>
          <span>{{ item.orderer_document_name || "aniqlanmagan" }}</span>
        </div>
        <div>
          <p>Хужжат рақами ва санаси:</p>
          <span>{{ item.orderer_document_date?.split('T')[0] || "aniqlanmagan" }}</span>
        </div>
        <div>
          <p>Yuklab olish:</p>

          <span v-if="item.link"><img :src="pdf" class="pdf" alt="pdf" /></span>
          <span v-else>aniqlanmagan</span>
        </div>
      </div>
    </fieldset>
  </div>
  <div v-if="item && item.id == 2" class="chronology animateWrapper">
    <fieldset class="">
      <legend>
        <img :src="board" alt="board" />
        <span>Лойиҳачи ташкилот</span>
      </legend>
      <div class="field">
        <div>
          <p>Номи:</p>
          <span>{{ item.designerName || " aniqlanmagan" }}</span>
        </div>
        <div>
          <p>СТИР:</p>
          <span>{{ item.designerTin || " aniqlanmagan" }}</span>
        </div>
        <div>
          <p>Юридик манзили:</p>
          <span>{{ item.designerAddress || "aniqlanmagan" }}</span>
        </div>
        <div>
          <p>Раҳбари:</p>
          <span>{{ item.designerDirector || "aniqlanmagan" }}</span>
        </div>
        <div>
          <p>Аниқлаш тури:</p>
          <span>{{ item.designerType || "aniqlanmagan" }}</span>
        </div>
        <div>
          <p>Лот рақами:</p>
          <span>{{ item.designerLots || " aniqlanmagan" }}</span>
        </div>
        <div>
          <p>Харид баёни санаси:</p>
          <span v-if="item.designerLink">
            <img :src="link" alt="link" /> 2023-04-25</span
          >
          <span v-else> aniqlanmagan</span>
        </div>
      </div>
    </fieldset>
    <div class="accounts-wrapper">
      <fieldset>
        <legend>
          <span>Лойиҳа-смета ҳужжатлари</span>
        </legend>
        <div class="field">
          <div>
            <p>Лойиҳа-смета ҳужжати билан танишиш:</p>
            <span v-if="item.designerLink">
              <img :src="link" alt="link" /> 2023-04-25</span
            >
            <span v-else> aniqlanmagan</span>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>
          <span>Экспертизадан ўтказиш</span>
        </legend>
        <div class="field">
          <div>
            <p>Лойиҳа-смета ҳужжатига давлат экспертизаси хулосаси берилган</p>
            <span v-if="item.designerLink">
              <img :src="link" alt="link" /> 2023-04-25</span
            >
            <span v-else> aniqlanmagan</span>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>
          <span>Лойиҳачи ташкилотга тўловлар</span>
        </legend>
        <div class="payments">
          <div>
            <img :src="offer" alt="offer" />
            <span>Шартнома</span>
          </div>
          <div>
            <img :src="payments" alt="payments" />
            <span>Тўловлар</span>
          </div>
          <div>
            <img :src="schot_faktura" alt="faktura" />
            <span>Счет-фактура</span>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
  <div v-if="item && item.id == 3" class="chronology animateWrapper">
    <fieldset class="">
      <legend>
        <img :src="board" alt="board" />
        <span>Пудратчи ташкилот</span>
      </legend>
      <div class="field">
        <div>
          <p>Номи:</p>
          <span>{{ item.builderName || " aniqlanmagan" }}</span>
        </div>
        <div>
          <p>СТИР:</p>
          <span>{{ item.builderTin || " aniqlanmagan" }}</span>
        </div>
        <div>
          <p>Юридик манзили:</p>
          <span>{{ item.builderAddress || " aniqlanmagan" }}</span>
        </div>
        <div>
          <p>Раҳбари:</p>
          <span>{{ item.builderDirector || " aniqlanmagan" }}</span>
        </div>
        <div>
          <p>Аниқлаш тури:</p>
          <span>{{ item.builderType || " aniqlanmagan" }}</span>
        </div>
        <div>
          <p>Лот рақами:</p>
          <span>{{ item.buildeLots || " aniqlanmagan" }}</span>
        </div>
        <div>
          <p>Харид баёни санаси:</p>
          <span v-if="item.designerLink">
            <img :src="link" alt="link" /> 2023-04-25</span
          >
          <span v-else> aniqlanmagan</span>
        </div>
      </div>
    </fieldset>
    <div class="accounts-wrapper">
      <fieldset>
        <legend>
          <span>Қурилиш-таъмирлаш хужжатлари</span>
        </legend>

        <div class="field">
          <div>
            <p>Қурилиш тури::</p>
            <span>{{ item.constructionTypeName || " aniqlanmagan" }}</span>
          </div>
          <div>
            <p>Даврийлиги:</p>
            <span>{{ item.periodicityName || " aniqlanmagan" }}</span>
          </div>
          <div>
            <p>Амалга ошириш муддати:</p>
            {{ item.implementationPeriod || " aniqlanmagan" }}
          </div>
          <div>
            <p>Объектнинг тасдиқланган бош режаси:</p>
            <span v-if="item.designerLink">
              <img :src="link" alt="link" /> 2023-04-25</span
            >
            <span v-else> aniqlanmagan</span>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>
          <span>Буюртмачи ташкилотга тўловлар</span>
        </legend>
        <div class="payments">
          <div>
            <img :src="offer" alt="offer" />
            <span>Шартнома</span>
          </div>
          <div>
            <img :src="payments" alt="payments" />
            <span>Тўловлар</span>
          </div>
          <div>
            <img :src="schot_faktura" alt="faktura" />
            <span>Счет-фактура</span>
          </div>
        </div>
      </fieldset>
    </div>
  </div>

  <div v-if="item && item.id == 4" class="animateWrapper">
    <div class="finished-details">
      <div>
        <div class="flex-item">
          <img :src="flag" alt="flag" />
          <p>Фойдаланишга топширилган сана</p>
        </div>
        <p>{{ item.date_put_into_use || " aniqlanmagan" }}</p>
      </div>
      <div>
        <div class="flex-item">
          <img :src="organization" alt="flag" />
          <p>Қабул қилган орган номи</p>
        </div>
        <p>{{ item.received_org || " aniqlanmagan" }}</p>
      </div>
      <div>
        <div class="flex-item">
          <img :src="document" alt="flag" />
          <p>Қабул қилиш далолатномаси</p>
        </div>
        {{ " aniqlanmagan" }}
      </div>
    </div>
    <div class="photos">
      <p class="sub-title">Топширилган объект фотосуръатлари</p>
      aniqlanmoqda'
      <!-- <Gallery :index="1" :items="photos" /> -->
    </div>
  </div>
</template>

<style scoped lang="scss">
.title {
  margin-bottom: 25px;
  text-align: center;
}
.chronology {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.animateWrapper {
  opacity: 0;
  animation: show 0.5s linear forwards;
  transform: translateY(-20px);
}
@keyframes show {
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.photos {
}

.finished-details > div {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
  // background: red;
  .flex-item {
    display: flex;
    align-items: center;
    gap: 20px;
    p {
      width: 70%;
      color: black;
    }
  }
  p {
    color: #0271a0;
  }
}

.field {
  margin-top: 10px;
  div {
    margin-bottom: 10px;
    p {
      font-weight: 500;
    }
    span {
      font-size: 12px;
      color: #0271a0;

      img.pdf {
        background: red;
      }
    }
  }
}

fieldset.makeWhiteBg {
  background: #f5f5f5;
  box-shadow: 5px 6px 6px 0px #ccc;
}

.accounts-wrapper {
  width: 45%;
  fieldset {
    width: 100% !important;
  }
  .account {
    text-align: center;
    margin-bottom: 10px;
  }
}

fieldset {
  background: #ffffff;
  box-shadow: 5px 6px 6px 0px #ccc;
  border: 1px solid #d8dde3;
  border-radius: 5px;
  margin-bottom: 20px;
  transition: 0.3s ease;
  width: 45%;
  padding: 10px;
  legend {
    font-size: 15px;
    font-weight: 500;
    color: #0271a0;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  &:hover {
    background: #f5f5f5;
    box-shadow: 5px 6px 6px 0px #ccc;
  }

  .payments {
    display: flex;
    align-items: center;
    justify-content: space-between;
    div {
      display: flex;
      align-items: center;
      flex-direction: column;
      span {
        font-size: 13px;
        font-weight: 500;
        color: #0271a0;
      }
    }
  }
}

@media screen and (width: 1024px) {
  .chronology {
    flex-direction: column;
  }
  fieldset,
  .accounts-wrapper {
    width: 100%;
  }
}
@media screen and (width: 768px) {
  .chronology {
    flex-direction: column;
  }
  fieldset,
  .accounts-wrapper {
    width: 100%;
  }
}
@media screen and (width: 425px) {
  .chronology {
    flex-direction: column;
  }
  fieldset,
  .accounts-wrapper {
    width: 100%;
  }
}
@media screen and (width: 375px) {
  .chronology {
    flex-direction: column;
  }
  fieldset,
  .accounts-wrapper {
    width: 100%;
  }
}
</style>
